import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, DateDecoder, field, StringDecoder } from '@simonbackx/simple-encoding';
import { Formatter } from '@stamhoofd/utility';
import { AuditLogReplacement } from '../AuditLogReplacement.js';
/**
 * Keep a timestamp of when certain information was reviewed of a member
 */
export class ReviewTime extends AutoEncoder {
    name;
    /**
     * Date that this section was reviewed
     */
    reviewedAt;
    getDiffName() {
        return AuditLogReplacement.key('reviewTime.' + this.name);
    }
    getDiffValue() {
        return AuditLogReplacement.string(Formatter.dateNumber(this.reviewedAt, true));
    }
}
__decorate([
    field({ decoder: StringDecoder })
], ReviewTime.prototype, "name", void 0);
__decorate([
    field({ decoder: DateDecoder })
], ReviewTime.prototype, "reviewedAt", void 0);
export class ReviewTimes extends AutoEncoder {
    times = [];
    markReviewed(name, date) {
        for (const time of this.times) {
            if (time.name === name) {
                if (date && date < time.reviewedAt) {
                    // Can't decrease time
                    return;
                }
                time.reviewedAt = date ?? new Date();
                return;
            }
        }
        this.times.push(ReviewTime.create({
            name,
            reviewedAt: date ?? new Date(),
        }));
    }
    removeReview(name) {
        this.times = this.times.filter(t => t.name !== name);
    }
    getLastReview(name) {
        if (!name) {
            if (this.times.length === 0) {
                return;
            }
            return new Date(Math.min(...this.times.map(t => t.reviewedAt.getTime())));
        }
        for (const time of this.times) {
            if (time.name === name) {
                return time.reviewedAt;
            }
        }
    }
    merge(other) {
        for (const time of other.times) {
            this.markReviewed(time.name, time.reviewedAt);
        }
    }
    isReviewed(name) {
        const time = this.getLastReview(name);
        if (!time) {
            return false;
        }
        return true;
    }
    isOutdated(name, timeoutMs) {
        const time = this.getLastReview(name);
        if (!time) {
            return true;
        }
        if (time.getTime() < new Date().getTime() - timeoutMs) {
            return true;
        }
        return false;
    }
    clearAll() {
        this.times = [];
    }
}
__decorate([
    field({ decoder: new ArrayDecoder(ReviewTime) })
], ReviewTimes.prototype, "times", void 0);
//# sourceMappingURL=ReviewTime.js.map